import { render } from "./NeuroMotorFormulario.vue?vue&type=template&id=4128192f&scoped=true"
import script from "./NeuroMotorFormulario.vue?vue&type=script&lang=js"
export * from "./NeuroMotorFormulario.vue?vue&type=script&lang=js"

import "./NeuroMotorFormulario.vue?vue&type=style&index=0&id=4128192f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4128192f"]])

export default __exports__